export { default as Router } from './lib/Router';



//////////////////
// WEBPACK FOOTER
// /Users/Jovan/TitanNanoDE/node_modules/@af-modules/router/main.js
// module id = 19
// module chunks = 0